import React, { useState, useContext, useEffect } from "react";
import { MdEmail, MdLock, MdPhone, MdPerson } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import logo from "../assets/rentastic.png";
import bgImage from "../assets/toys-bg.png";
import { AuthContext } from "../../context/AuthContext"; // ✅ import context

const SignUp = () => {
  const navigate = useNavigate();
  const { signup } = useContext(AuthContext); // ✅ use signup API

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    agree: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password.length < 6) {
      alert("Password must be at least 6 characters long!");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    if (!formData.agree) {
      alert("You must agree to the Terms & Policy.");
      return;
    }

    // Call signup API
    const res = await signup(formData);
    
    if (res.status === 201 || res.status === "201") {
      alert("Account created successfully!");
      navigate("/login");
    } else {
      alert(res.messages.error || "Signup failed");
    }
  };

  useEffect(() => {
    const user_id = localStorage.getItem("user_id");
    if (user_id) {
      navigate("/", { replace: true }); // redirect and replace history
    }
  }, [navigate]);

  return (
    <section
      className="min-h-screen flex justify-center md:justify-end items-center bg-cover bg-center"
      style={{ backgroundImage: `url("https://cdn.acsdev.in/Rentastic/toysb.png")` }}
    >
      <div className="w-full max-w-md sm:max-w-sm md:max-w-md lg:max-w-lg bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg p-6 sm:p-8 md:p-10 mx-4 md:mr-16 lg:mr-32">
        {/* Logo */}
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center bg-green-100 mb-3">
            <img src="https://cdn.acsdev.in/Rentastic/rentastic.png" alt="logo" className="w-10 h-10" />
          </div>
          <h1 className="text-lg font-bold text-gray-800">Rentastic Toys</h1>
          <p className="text-md font-semibold text-gray-900 mt-2">
            Create Your Account
          </p>
          <p className="text-sm text-gray-500 mt-1 text-center px-4">
            Please fill in your details to sign up.
          </p>
        </div>

        {/* Form */}
        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          {/* First & Last Name */}
          <div className="flex flex-col sm:flex-row sm:space-x-3 space-y-3 sm:space-y-0">
            <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500 w-full sm:w-1/2">
              <MdPerson className="text-gray-500 text-lg mr-2" />
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                className="w-full py-2 outline-none text-gray-700 bg-transparent"
                required
                aria-label="First Name"
              />
            </div>
            <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500 w-full sm:w-1/2">
              <MdPerson className="text-gray-500 text-lg mr-2" />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                className="w-full py-2 outline-none text-gray-700 bg-transparent"
                required
                aria-label="Last Name"
              />
            </div>
          </div>

          {/* Email */}
          <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500">
            <MdEmail className="text-red-500 text-lg mr-2" aria-hidden="true" />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              className="w-full py-2 outline-none text-gray-700 bg-transparent"
              required
              aria-label="Email Address"
            />
          </div>

          {/* Phone */}
          <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500">
            <MdPhone className="text-gray-500 text-lg mr-2" aria-hidden="true" />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              className="w-full py-2 outline-none text-gray-700 bg-transparent"
              required
              aria-label="Phone Number"
            />
          </div>

          {/* Password */}
          <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500">
            <MdLock className="text-gray-500 text-lg mr-2" aria-hidden="true" />
            <input
              type="password"
              name="password"
              placeholder="Password (min 6 chars)"
              minLength={6}
              value={formData.password}
              onChange={handleChange}
              className="w-full py-2 outline-none text-gray-700 bg-transparent"
              required
              aria-label="Password"
            />
          </div>

          {/* Confirm Password */}
          <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500">
            <MdLock className="text-gray-500 text-lg mr-2" aria-hidden="true" />
            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="w-full py-2 outline-none text-gray-700 bg-transparent"
              required
              aria-label="Confirm Password"
            />
          </div>

          {/* Terms & Policy */}
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
              className="w-4 h-4 text-green-500 border-gray-300 rounded focus:ring-green-500"
              required
              aria-describedby="terms-description"
            />
            <label className="text-sm text-gray-600" id="terms-description">
              I agree to the{" "}
              <a href="/terms" className="text-orange-500 hover:underline">
                Terms
              </a>{" "}
              &{" "}
              <a href="/privacypolicy" className="text-orange-500 hover:underline">
                Policy
              </a>
            </label>
          </div>

          <button
            type="submit"
            className="w-full bg-green-500 text-white font-semibold py-2 rounded-full shadow hover:bg-green-600 transition focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
          >
            Sign Up
          </button>
        </form>

        <div className="text-center mt-6 text-sm text-gray-600">
          Already have an account?{" "}
          <button
            type="button"
            onClick={() => navigate("/login")}
            className="text-orange-500 font-semibold hover:underline focus:outline-none focus:underline"
          >
            Login
          </button>
        </div>
      </div>
    </section>
  );
};

export default SignUp;
